import { colors, font, maxWidth } from "../styles/theme";
import { aboutStats, aboutPoints } from "../data/about";
import { useRequestModal } from "../components/ModalProvider";

// Блок «О компании» — кто мы, цифры, преимущества.
export default function AboutSection() {
  const { openRequest } = useRequestModal();

  return (
    <section id="about" className="section-pad" style={{ position: "relative", background: "#fff", padding: "72px 22px", overflow: "hidden" }}>
      <div style={{ position: "relative", zIndex: 1, maxWidth, margin: "0 auto" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 48, alignItems: "stretch" }}>
          {/* Левая колонка — текст + статистика */}
          <div style={{ flex: "1 1 440px", minWidth: "min(100%,440px)", display: "flex", flexDirection: "column" }}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                fontFamily: font.display,
                fontWeight: 600,
                fontSize: 12,
                letterSpacing: ".16em",
                textTransform: "uppercase",
                color: colors.red,
              }}
            >
              <span style={{ width: 26, height: 2, background: colors.red, display: "inline-block" }} />
              О компании
            </span>
            <h2
              style={{
                fontFamily: font.display,
                fontWeight: 700,
                fontSize: "clamp(2rem,4vw,3.2rem)",
                lineHeight: 1.05,
                textTransform: "uppercase",
                margin: "14px 0 0",
                color: colors.ink,
              }}
            >
              Климат под ключ <span style={{ color: colors.red }}>с 2007 года</span>
            </h2>
            <p style={{ fontSize: 17, lineHeight: 1.65, color: colors.text, margin: "20px 0 0", maxWidth: 560 }}>
              ВК-КЛИМАТ — инженерная компания полного цикла из Дмитрова. Более 19 лет проектируем, монтируем и
              обслуживаем системы вентиляции, кондиционирования и отопления для домов, коттеджей и коммерческих объектов
              в Дмитрове, Дмитровском районе и по всей Московской области. За это время мы сдали более 500 объектов — от
              квартир до бизнес-центров и производств.
            </p>
            <p style={{ fontSize: 17, lineHeight: 1.65, color: colors.text, margin: "16px 0 0", maxWidth: 560 }}>
              Работаем по договору с фиксированной сметой и гарантией. Наша задача — чтобы климат в вашем помещении был
              комфортным, тихим и экономичным, а вы не возвращались к этому вопросу годами.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
                gap: 18,
                marginTop: 32,
              }}
            >
              {aboutStats.map((s) => (
                <div key={s.label} style={{ borderLeft: `3px solid ${colors.red}`, padding: "2px 0 2px 14px" }}>
                  <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: "clamp(26px,3.4vw,38px)", lineHeight: 1, color: colors.ink }}>
                    {s.value}
                  </div>
                  <div style={{ fontFamily: font.body, fontSize: 12, letterSpacing: ".04em", textTransform: "uppercase", color: colors.muted, marginTop: 7, lineHeight: 1.3 }}>
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: "auto", paddingTop: 32 }}>
              <button
                onClick={openRequest}
                style={{
                  background: colors.ink,
                  color: "#fff",
                  border: "none",
                  fontFamily: font.display,
                  fontWeight: 600,
                  fontSize: 15,
                  letterSpacing: ".04em",
                  textTransform: "uppercase",
                  padding: "16px 32px",
                  borderRadius: 10,
                  cursor: "pointer",
                  transition: "background .18s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = colors.red)}
                onMouseLeave={(e) => (e.currentTarget.style.background = colors.ink)}
              >
                Обсудить проект
              </button>
            </div>
          </div>

          {/* Правая колонка — фото с плашкой опыта */}
          <div style={{ flex: "1 1 380px", minWidth: "min(100%,380px)" }}>
            <div style={{ position: "relative", height: "100%", minHeight: 360, borderRadius: 20, overflow: "hidden" }}>
              <img
                src="/about.webp"
                alt="Монтаж климатических систем ВК-КЛИМАТ"
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(160deg,rgba(8,8,11,.25),rgba(8,8,11,.55))" }} />
              <div
                style={{
                  position: "absolute",
                  left: 20,
                  bottom: 20,
                  right: 20,
                  background: "rgba(255,255,255,.10)",
                  border: "1px solid rgba(255,255,255,.22)",
                  backdropFilter: "blur(8px)",
                  WebkitBackdropFilter: "blur(8px)",
                  borderRadius: 14,
                  padding: "20px 22px",
                  color: "#fff",
                }}
              >
                <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: 40, lineHeight: 1 }}>19+</div>
                <div style={{ fontFamily: font.display, fontWeight: 600, fontSize: 13, letterSpacing: ".06em", textTransform: "uppercase", marginTop: 6 }}>
                  лет опыта в инженерных системах
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Преимущества */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
            gap: 20,
            marginTop: 50,
          }}
        >
          {aboutPoints.map((p, i) => (
            <div
              key={p.title}
              style={{
                background: colors.bgLight,
                border: "1px solid #e6e9ee",
                borderRadius: 16,
                padding: "26px 24px",
              }}
            >
              <div style={{ fontFamily: font.display, fontWeight: 700, fontSize: 30, color: "#dfe3e9", lineHeight: 1 }}>
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 style={{ fontFamily: font.display, fontWeight: 600, fontSize: 18, textTransform: "uppercase", margin: "14px 0 0", color: colors.ink }}>
                {p.title}
              </h3>
              <p style={{ margin: "10px 0 0", fontSize: 14.5, lineHeight: 1.55, color: "#5b6470" }}>{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
